import Cookies from "js-cookie";
import config from "./config";
import { apiCheckAccountStatus } from "../api/account";

export const is_user_authenticated = async () => {
  try {
    const userToken = Cookies.get(config.key.ACCESS_TOKEN_KEY);
    return !!userToken; // Convert to boolean - true if token exists, false if not
  } catch (error) {
    console.error("Error reading user token status:", error);
    return false;
  }
};

interface StorageData {
  verified: boolean;
  account_profile: {
    id: number;
    name: string;
    image: string;
    kyced: number;
    id_uploaded: number;
  };
}
export const initialize_storage_data = async (): Promise<StorageData> => {
  try {
    // Get all items in parallel
    const [verifiedStr, accountProfileStr] = await Promise.all([
      Cookies.get(config.key.ACCOUNT_VERIFIED),
      Cookies.get(config.key.ACCOUNT_PROFILE),
    ]);

    // Parse the data with default values if null
    const verified = verifiedStr ? JSON.parse(verifiedStr) : false;
    const account_profile = accountProfileStr
      ? JSON.parse(accountProfileStr)
      : { id: 0, name: "", image: "", kyced: 0, id_uploaded: 0 };
    return {
      verified,
      account_profile,
    };
  } catch (error) {
    console.error("Error loading data from AsyncStorage:", error);
    // Return default values if there's an error
    return {
      verified: false,
      account_profile: { id: 0, name: "", image: "", kyced: 0, id_uploaded: 0 },
    };
  }
};

export const updateAccessToken = async (
  accessToken: string,
  tokenExpirationDate: number,
  tokenType: string
) => {
  try {
    Cookies.set(config.key.ACCESS_TOKEN_KEY, accessToken, {
      expires: 2 / 24, // 1/24 of a day = 1 hour
    });
    Cookies.set(config.key.ACCESS_TOKEN_TYPE, tokenType);
  } catch (error) {
    console.error("Error updating user token:", error);
  }
};

export const getAccessToken = async () => {
  try {
    const accessToken = Cookies.get(config.key.ACCESS_TOKEN_KEY);
    const tokenType = Cookies.get(config.key.ACCESS_TOKEN_TYPE);
    const tokenExpirationDate = Cookies.get(
      config.key.ACCESS_TOKEN_EXPIRES_KEY
    );

    return {
      accessToken,
      tokenType,
      tokenExpirationDate: tokenExpirationDate
        ? parseInt(tokenExpirationDate, 10)
        : null,
    };
  } catch (error) {
    console.error("Error getting user token:", error);
    return {
      accessToken: null,
      tokenType: null,
      tokenExpirationDate: null,
    };
  }
};
